import { Button } from "@material-ui/core";

import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

export const FileDownloadSimpleButton = withShowIf(Button);
